import { render } from "./BudgetForm.vue?vue&type=template&id=02dee410&scoped=true&ts=true"
import script from "./BudgetForm.ts?vue&type=script&lang=ts"
export * from "./BudgetForm.ts?vue&type=script&lang=ts"

import "./BudgetForm.scss?vue&type=style&index=0&id=02dee410&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02dee410"]])

export default __exports__